import { call, put, takeEvery } from 'redux-saga/effects'
import { SEND_POST_MESSAGE, SEND_POST_MESSAGE_FAIL, SEND_POST_MESSAGE_SUCCESS } from "../actions"
import constants from "../constants"
import sendPostMessage from "../services/post-communication"

function* onPostMessage({payload = {}}) {
    try {
        yield call(sendPostMessage, { payload, ...constants.USER_ACTIONS.sendMessage })
        yield put({ type: SEND_POST_MESSAGE_SUCCESS, payload })
    } catch (err) {
        yield put({ type: SEND_POST_MESSAGE_FAIL, payload: err })
    }
}

function* postMessage() {
  yield takeEvery(SEND_POST_MESSAGE, onPostMessage)
}

export default postMessage


// WEBPACK FOOTER //
// ./src/sagas/post-message.js